import React from 'react';

function ChamadoActionsCard({ onIniciar, onPausar, onConcluir }) {
    return (
        <div className="chamado-sidebar-card chamado-actions-card">
            <h4 className="chamado-sidebar-card-titulo">Ações</h4>
            <div className="chamado-actions-buttons">
                <button type="button" className="chamado-action-btn chamado-action-play" onClick={onIniciar} title="Iniciar atendimento">
                    <i className="fas fa-play" aria-hidden="true" /> Iniciar atendimento
                </button>
                <button type="button" className="chamado-action-btn chamado-action-pause" onClick={onPausar} title="Pausar">
                    <i className="fas fa-pause" aria-hidden="true" /> Pausar
                </button>
                <button type="button" className="chamado-action-btn chamado-action-concluir" onClick={onConcluir} title="Concluir chamado">
                    <i className="fas fa-check" aria-hidden="true" /> Concluir chamado
                </button>
            </div>
        </div>
    );
}

export default ChamadoActionsCard;
